
import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { InputCurrencyDirective } from '../../directives/input/currency/currency';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';

@Component({
    selector: 'cerrix-input-currency',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    InputCurrencyDirective
],
    templateUrl: './cerrix-input-currency.component.html',
    styleUrl: './cerrix-input-currency.component.scss'
})
export class CerrixInputCurrencyComponent
  implements OnInit, OnChanges, ControlValueAccessor
{
  @Input() public value: string = '';
  @Output() public valueChange: EventEmitter<string> =
    new EventEmitter<string>();
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;
  @Input() public autocomplete: boolean = true;
  @Input() public currencyPrefix?: string;

  protected focused: boolean = false;

  protected errorMatcher!: ErrorStateMatcher;
  protected ngControl = inject(NgControl, { optional: true, self: true });
  private readonly destroyRef = inject(DestroyRef);

  private onValueChange = (value: string) => {};
  private onTouched = () => {};

  public writeValue(value: string): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: string) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.disabled) {
      this.onFocusOut(false);
    }
  }
  ngOnInit(): void {
    this.onFocusOut(false);
  }

  protected onChange(event: Event) {
    this.value = (event.target as HTMLInputElement)?.value;
    this.onValueChange(this.value);
  }

  protected onFocus(): void {
    this.focused = true;

    this.value = this.value.replaceAll('.', '');
  }

  protected onFocusOut(emit: boolean = true): void {
    this.focused = false;

    if (this.value !== undefined && this.value !== null) {
      if (this.value === ',') {
        this.value = '';
      }
      if (this.value.startsWith(',')) {
        this.value = this.value.replace(',', '0,');
      }
      this.value = this.value.replace(
        /(?<commanumber>,\d$)/g,
        '$<commanumber>0'
      );
      this.value = this.value.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1.');
      if (
        this.value !== '' &&
        new RegExp(/^(?:(?!,\d).)*$/, 'g').test(this.value)
      ) {
        this.value = this.value + ',00';
      }
    }
    this.onValueChange(this.value);
    if (emit) {
      this.valueChange.emit(this.value);
    }
  }
}
